import React from "react";
import { useI18n } from "@/contexts/I18nContext";

const styles = {
  High: "bg-red-100 text-red-800 border-red-200 dark:bg-red-950/40 dark:text-red-300 dark:border-red-900",
  Medium: "bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-900",
  Low: "bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-900",
};

// Step 3 combined · B4: a discrepancy difference with no clearly trivial set is stored "Not rated" (was Medium)
const NOT_RATED = "Not rated";

export default function RiskBadge({ level, className = "" }) {
  const { t } = useI18n();
  const label = level === NOT_RATED ? t("s3c.riskNotRated") : t(`common.${(level || "").toLowerCase()}`);
  return (
    <span
      data-testid={`risk-badge-${(level || "").toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-medium ${styles[level] || "bg-slate-100 text-slate-700 border-slate-200"} ${className}`}
    >
      {label || level}
    </span>
  );
}
